<template>
  <div
    v-if="feedbackComponent"
    style="
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    "
  >
    <div class="sessionFont" style="width: 100%">
      <div
        class="h3"
        style="display: flex; justify-content: center"
        v-if="feedBackHeaderText == '' && notesBeforeFeedBack == ''"
      >
        How was your Session
      </div>
      <div
        class="h3"
        style="display: flex; justify-content: center"
        v-if="feedBackHeaderText == '' && notesBeforeFeedBack != ''"
      >
        {{ notesBeforeFeedBack }}
      </div>
      <div class="h3" style="display: flex; justify-content: center" v-else>
        {{ feedBackHeaderText }}
      </div>
      <div class="h4" style="display: flex; justify-content: center">
        {{ ratedSession.Name }}
      </div>
      <div
        style="display: flex; justify-content: center; font-size: 16px"
        v-if="!showFeedbackDropDown"
      >
        {{ getFeedbackSessionDate() }}
      </div>
      <div v-else style="width: 100%">
        <div style="width: 300px; margin: 0 auto">
          <v-autocomplete
            class="checkScroller"
            :items="allSessionDetails"
            :disabled="contentLoadedAuto"
            :loading="contentLoadedAuto"
            prepend-inner-icon="search"
            return-object
            hide-details
            :item-text="createdSessionName"
            v-model="selectedSession"
            clearable
            label="Search Session"
            dense
            outlined
            @change="getReviewDetails(selectedSession)"
          >
          </v-autocomplete>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div class="mt-10">
          <vue-feedback-reaction
            emojiWidth="60px"
            emojiHeight="60px"
            v-model="feedback"
            :labels="['Very Poor', 'Poor', 'Average', 'Good', 'Excellent']"
          />
        </div>
        <div style="position: relative; bottom: 0; width: 50%" class="mt-5">
          <v-textarea
            name="input-7-1"
            no-resize
            outlined
            v-model="ratingText"
            hide-details
          >
            <template #label>
              <span style="font-weight: bold">
                Additional feedback or comments about your experience</span
              ></template
            >
          </v-textarea>
          <div
            v-if="ratedDate && feedback"
            style="display: flex; justify-content: flex-end; font-size: 12px"
          >
            Rated on {{ getFeedbackCreationDate() }}
          </div>
          <div style="display: flex; justify-content: center" class="pt-3">
            <div class="pr-3">
              <v-btn @click="cancelFeedback()">Skip</v-btn>
            </div>
            <div v-if="disableFeedbackSubmit == false">
              <v-btn
                :loading="submitFeedbackLoader"
                color="primary"
                :disabled="!feedback || !ratingText"
                @click="submitFeedback()"
                >Submit</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else-if="dialog" style="height:fit-content; !important">
    <v-row align="centre" justify="centre">
      <v-icon
        style="display: absolute"
        class="pt-3 pl-2 ml-8"
        @click="dialog = false"
        size="36"
      >
        mdi-arrow-left
      </v-icon>
      <v-spacer></v-spacer>
      <div class="pt-4">
        <h3>{{ sessionData.Name }}</h3>
      </div>
      <v-spacer></v-spacer>
    </v-row>
    <v-row justify="center" class="position-relative">
      <v-col
        v-if="playListController.length > 1"
        class="ml-n8 videopart-wrap mr-0 pr-0"
        cols="3"
      >
        <div class="video-play-list-wrap">
          <div class="playlist-head">
            <h5>
              Playlist <span>{{ playListController.length }} Videos</span>
            </h5>
          </div>
          <div class="videolist-wrap-hld">
            <div
              class="play-video-listing py-0"
              :style="video.clicked ? 'background-color:#E3F2FD' : ''"
              v-for="(video, i) in playListController"
              :key="i"
              @click="resetVideo(video, i)"
            >
              <div
                style="cursor: pointer; border: 1px solid #ccc !important"
                class="
                  mb-1
                  video-part
                  d-flex
                  justify-content-center
                  align-items-center
                "
                justify="center"
                align="center"
              >
                <v-icon color="#EEEEEE" size="48">mdi-play</v-icon>
              </div>
              <div class="video-details-wrap">
                <p>Part {{ i + 1 }}</p>
                <!-- <p class="video-time">50:16</p> -->
                <div>
                  <v-btn
                    color="#6cb649"
                    dark
                    small
                    @click="downloadVideo(video.sources[0].src)"
                    ><v-icon depressed color="#fff">mdi-download</v-icon>
                    Download</v-btn
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-btn
        color="#6cb649"
        dark
        class="download-watch-now"
        @click="downloadVideo()"
        ><v-icon depressed color="#fff">mdi-download</v-icon> Download</v-btn
      >
      <v-col class="videoElement ml-0 pl-0" cols="8">
        <VideoPlayer
          :disablePictureInPicture="true"
          :options="videoPlayerOptions"
          class="vjs-custom-skin"
          style="width: auto !important"
          ref="videoPlayer"
        >
        </VideoPlayer
      ></v-col>
    </v-row>
  </div>
  <div
    v-else
    @keyup.enter="changeDrawerState()"
    class="pt-0"
    style="height: fit-content"
  >
    <div class="fixed-top-dialog-head mt-4">
      <v-row v-if="!$vuetify.breakpoint.smAndDown" no-gutters class="pa-3">
        <v-col md="6">
          <span
            style="position: relative"
            class="page-head text-uppercase mb-0"
            >{{ $t("sessions.sessions") }}</span
          >
        </v-col>

        <v-col md="6" v-if="isClientAdmin() == true">
          <v-row class="d-flex justify-content-end align-items-center">
            <v-col md="6">
              <div>
                <v-autocomplete
                  :items="allCourseList"
                  prepend-inner-icon="search"
                  clearable
                  return-object
                  hide-details
                  :item-text="'EventFullName'"
                  :item-value="'EventId'"
                  v-model="selectedCourse"
                  placeholder="Select Course"
                  dense
                  outlined
                  :loading="loadCourse"
                  @change="filterSessionList()"
                >
                </v-autocomplete>
              </div>
            </v-col>
            <v-col md="6">
              <v-autocomplete
                v-if="allUsersListOfClient && isClientAdmin() == true"
                :items="allUsersListOfClient"
                prepend-inner-icon="search"
                clearable
                :item-text="'user_name'"
                :item-value="'user_email'"
                v-model="selectedUser"
                placeholder="Select User"
                dense
                outlined
                :loading="loadUser"
                @change="filterSessionList()"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-row class="fill-height ml-2 mb-2 pt-0 pa-0 mt-0">
      <v-col
        ref="SessionCalendar"
        style="position: fixed; z-index: 2"
        class=""
        v-if="!$vuetify.breakpoint.mobile"
        cols="auto"
      >
        <v-row class="position-relative"
          ><v-date-picker
            v-model="picker"
            :style="'top:' + navbarHeight + 'px;position: sticky'"
            flat
            no-title
          />

          <div
            class="class-table-chart"
            style="
              margin: 0px;
              position: absolute;
              height: 164px;
              overflow-y: auto;
              width: 100%;
              overflow-x: hidden;
              bottom: -107px;
              background: #fff;
            "
            v-if="certificateData.length > 0"
          >
            <table
              style="
                width: 240px;
                position: relative;
                height: 150px;
                border-radius: 6px;
                overflow: hidden;
              "
            >
              <thead>
                <tr>
                  <th
                    width="100%"
                    colspan="2"
                    style="
                      line-height: 27px;
                      margin-left: 5px;
                      background: transparent !important;
                    "
                  >
                    Course Progress
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  height="60"
                  v-for="(course) in certificateData"
                  :key="course.course_id"
                >
                  <td>
                    <div
                      class="
                        flie-wrap
                        d-flex
                        justify-content-start
                        align-items-center
                      "
                    >
                      <h4 class="m-0" style="font-size: 12px !important">
                        {{ course.course_name }}
                      </h4>
                    </div>
                  </td>
                  <td>
                    <p
                      class="certificate-progress"
                      style="width: 80px"
                      v-if="course.completionPercentage < 100"
                    >
                      <v-progress-linear
                        :color="
                          course.completionPercentage > 10 &&
                          course.completionPercentage < 40
                            ? 'amber'
                            : course.completionPercentage > 40 &&
                              course.completionPercentage < 60
                            ? 'blue'
                            : course.completionPercentage > 60 &&
                              course.completionPercentage <= 99
                            ? 'light-green'
                            : course.completionPercentage >= 100
                            ? 'Success'
                            : ''
                        "
                        slot="extension"
                        v-model="course.completionPercentage"
                        class="ma-0"
                      ></v-progress-linear>

                      <span class="progress-number-right"
                        >{{ course.attended_sessions }}/{{
                          course.purchased_sessions
                        }}</span
                      >
                    </p>
                    <p v-else class="m-0">
                      <v-chip
                        class="ma-2"
                        color="green"
                        text-color="green"
                        outlined
                        small
                      >
                        Completed
                      </v-chip>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-row>
      </v-col>
      <v-divider v-if="!$vuetify.breakpoint.mobile" vertical />

      <v-col :style="leftPadding" class="pt-0 ml-2 mt-2">
        <div>
          <v-btn @click="goToPreviousDate()" text
            ><v-icon>mdi-arrow-left </v-icon>
            <span> Previous Sessions</span></v-btn
          >
        </div>
        <v-row style="z-index: 2" class="mt-n7" justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  ref="myBtn"
                  rounded
                  style="z-index: 2"
                  outlined
                  class="mr-3 ml-3"
                  @click="setState('tab1')"
                  elevation="0"
                  retain-focus-on-click
                  :style="
                    hover || tabClick.tab1
                      ? 'background-color:black !important;color:white'
                      : 'background-color:#E3F2FD !important;color:grey'
                  "
                  >Past</v-btn
                >
              </v-hover>
            </template>
            <span>Filters only past sessions </span> </v-tooltip
          ><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  outlined
                  class="mr-3 ml-3"
                  @click="setState('tab2')"
                  elevation="0"
                  retain-focus-on-click
                  style="z-index: 2"
                  :style="
                    hover || tabClick.tab2
                      ? 'background-color:black !important;color:white'
                      : 'background-color:#E3F2FD !important;color:grey'
                  "
                  >Live/Upcoming</v-btn
                >
              </v-hover>
            </template>
            <span>Filters only Present and Upcoming sessions </span>
          </v-tooltip>
        </v-row>
        <v-row v-if="$vuetify.breakpoint.mobile" justify="end" align="end">
          <v-dialog v-model="showDatePickerDialog" width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                size="45"
                class="ma-2 mr-5"
                @click="showDatePickerDialog = true"
                v-bind="attrs"
                v-on="on"
              >
                date_range
              </v-icon>
            </template>
            <v-date-picker
              v-model="picker"
              style="'position: sticky'"
              flat
              no-title
            />
          </v-dialog>
        </v-row>
        <!-- <v-row :class="isSessionsOnDate && sessions.length?'mb-n10 pt-10':''" dense justify="left">
        <v-btn @click="goToPreviousDate()" text
          ><v-icon>mdi-arrow-left </v-icon>
          <span> Previous Sessions</span></v-btn
        >
        </v-row> -->
        <v-row
          v-if="isSessionsOnDate && sessions.length != 0"
          justify="center"
          class="pa-3"
        >
          <v-alert type="info"> No Sessions found for this Date </v-alert>
        </v-row>
        <v-row
          v-if="sessionsCount < 1 && !contentLoaded"
          class="fill-height"
          align="center"
          style="min-height: 60vh"
          justify="center"
        >
          <div class="no-class-session" v-if="tabClick.tab2">
            <v-icon color="#8a8a8a" size="80px">mdi-access-point</v-icon>
            <p>
              There are no sessions scheduled on the selected day and upcoming
            </p>
          </div>
          <div class="no-class-session" v-else>
            <v-icon color="#8a8a8a" size="80px">mdi-record-rec</v-icon>
            <p>Please select the date to view you past session</p>
          </div>
        </v-row>
        <v-row
          v-if="contentLoaded"
          class="fill-height"
          style="min-height: 60vh"
          align="center"
          justify="center"
        >
          <v-progress-circular size="80" indeterminate color="primary" />
        </v-row>
        <div
          v-if="timelinePosition == -1 && sessionsCount > 0 && tabClick.tab2"
          class="pb-5"
        >
          <div class="hr" />
          <div class="hrdot" />
        </div>

        <div
          class="no-class-session"
          v-if="
            sessions.length == 0 &&
            (selectedCourse != null || selectedUser != null)
          "
          style="margin-top: 90px"
        >
          <!-- <v-icon color="#8a8a8a" size="80px">mdi-access-point</v-icon> -->
          <p>There are no sessions available against the selected filter</p>
        </div>
        <v-col
          v-for="(session, index) in sessions"
          :key="session.SessionId"
          :class="
            (checkDate(index) ? 'pt-2' : '') +
            (isCurrentDate(session) ? ' scrollPos' : '')
          "
        >
          <v-col v-if="checkDate(index)" class="pt-0 sm-heading mb-3 pl-0">
            {{ getSessionDate(new Date(session.StartDate._seconds * 1000)) }}
          </v-col>
          <div
            style="cursor: pointer"
            @click.stop="(drawer = true), loadDrawerComponents(session)"
          >
            <SessionComponent
              :ref="'sessionComponent' + index"
              @onDemand="getVideoOnDemand"
              @rateMe="rateMe"
              @zoomDialogEmit="zoomDialogEmit"
              :session-data="session"
              :session-id="session.SessionId"
              :client-settings="clientSettings"
              :event-id="session.eventId"
              :is-host="session.isHost ? true : false"
            />
          </div>
          <div
            v-if="timelineIndex(index) && sessionsCount > 0 && tabClick.tab2"
          >
            <div class="hr" />
            <div class="hrdot" />
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-navigation-drawer
      v-model="showDatePicker"
      class="right-sidebar sessionFont"
      style="position: fixed"
      width="100%"
      right
      absolute
      temporary
    >
      <v-row justify="end" align="end" class="mt-3 mr-3">
        <v-img
          max-width="30px"
          style="cursor: pointer"
          src="../../assets/e2medu/icons/close-24px.svg"
          @click="showDatePicker = false"
        />
      </v-row>
      <v-row justify="center" align="center">
        <v-date-picker
          v-model="picker"
          style="'position: sticky'"
          flat
          no-title
        />
      </v-row>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="drawer"
      class="right-sidebar sessionFont"
      style="font-family: 'Poppins', sans-serif !important; position: fixed"
      width="440"
      right
      absolute
      temporary
    >
      <v-container class="px-6">
        <v-row justify="end" align="end">
          <div class="pt-2">
            <v-img
              width="30px"
              style="cursor: pointer"
              src="../../assets/e2medu/icons/close-24px.svg"
              @click="(drawer = false), closeDrawer(sessionData)"
            />
          </div>
        </v-row>
        <v-row class="mx-1 pt-0">
          <v-img
            style="border-radius: 5px"
            :src="
              sessionData
                ? sessionData.SessionLogo
                  ? sessionData.SessionLogo
                  : '../../assets/e2medu/default-session.jpg'
                : '../../assets/e2medu/default-session.jpg'
            "
          />
        </v-row>
        <v-row no-gutters class="pt-4">
          <v-icon
            :color="
              getStatus == 'Live'
                ? '#6cb649'
                : getStatus == 'Ended'
                ? '#b9bec1'
                : '#fcc53f'
            "
            size="10"
          >
            stop_circle </v-icon
          ><span class="pl-2 py-0 session-status">{{ getStatus }}</span>
        </v-row>
        <v-row no-gutters>
          <span class="grey-text">{{ $t("eventlist.event") }}</span>
        </v-row>
        <v-row style="font-size: 20px" no-gutters class="mt-0">
          {{ sessionData ? sessionData.eventInfo.EventFullName : "" }}
        </v-row>

        <v-row no-gutters class="grey-text pt-2"> Session </v-row>
        <v-row no-gutters class="h2 mt-0">
          <span style="font-size: 22px" class="rc-name">{{
            sessionData ? sessionData.Name : ""
          }}</span>
        </v-row>
        <v-row class="mt-2 mb-2" no-gutters>
          <v-icon pr-2> access_time </v-icon
          ><span class="ml-6">
            {{
              getTime(
                sessionData
                  ? new Date(sessionData.StartDate._seconds * 1000)
                  : null
              )
            }}
            -
            {{
              getTime(
                sessionData
                  ? new Date(sessionData.EndDate._seconds * 1000)
                  : null
              )
            }}</span
          >
        </v-row>
        <v-row no-gutters>
          <v-hover v-slot="{ hover }">
            <v-btn
              :disabled="getStatus != 'Live' && getStatus != 'Ended'"
              :dark="getStatus == 'Live' ? !hover : false"
              large
              block
              :loading="submitNavLoader"
              color="#6cb649"
              @click="
                getStatus == 'Ended' ? routeToZoom('onDemand') : routeToZoom()
              "
            >
              {{ getStatus == "Ended" ? "Watch Now" : "Join Now" }}
            </v-btn>
          </v-hover>
        </v-row>
        <v-row v-if="false" no-gutters>
          <v-btn style="font-weight: 600" large block text outlined>
            VIEW DETAILS
          </v-btn>
        </v-row>
        <v-row
          v-if="sessionData"
          class="font-weight-bold text-md-h6 pt-5"
          no-gutters
        >
          {{ $t("rightpanel.attendees") }} ({{
            sessionData.IncludedAttendees
              ? sessionData.IncludedAttendees.length
              : "0"
          }})
        </v-row>
        <div class="pt-3" dense v-if="sessionData" no-gutters>
          <v-row
            v-for="(item, index) in sessionData.IncludedAttendees"
            :key="index"
          >
            <v-col class="py-0 my-0">
              <v-chip color="#c7c7c7" class="ma-1">
                {{ item.Name }}
              </v-chip>
            </v-col>
            <v-col
              style="display: flex; flex-direction: row-reverse"
              class="py-0 my-0"
            >
              <v-btn
                v-if="sessionData.isHost && getStatus == 'Ended'"
                @click="setStudentBasedRating(item)"
                color="primary"
                text
                >Review</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <v-row
          v-if="
            sessionData &&
            sessionData.Resources &&
            sessionData.Resources.length > 0
          "
          class="mt-1"
          no-gutters
          ><span class="font-weight-bold text-md-h6 pt-2">
            {{ $t("sessions.resources") }}</span
          ></v-row
        >
        <v-row
          no-gutters
          class="pt-1"
          v-if="
            sessionData &&
            sessionData.Resources &&
            sessionData.Resources.length > 0
          "
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 92%;
                "
                v-on="on"
                v-bind="attrs"
              >
                <div
                  style="display: flex"
                  @click="dowloadFile(sessionData.Resources[0])"
                >
                  <v-img
                    max-width="30px"
                    max-height="30px"
                    style="cursor: pointer"
                    src="../../assets/e2medu/file.png"
                  >
                  </v-img>
                  <span style="cursor: pointer; align-self: center">
                    {{ getResourceName(sessionData.Resources[0]) }}</span
                  >
                </div>
              </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="dowloadFile(sessionData.Resources[0])"
                    style="cursor: pointer"
                    v-on="on"
                    v-bind="attrs"
                    >file_download</v-icon
                  > </template
                ><span>{{
                  getResourceName(sessionData.Resources[0])
                }}</span></v-tooltip
              >
            </template>
            <span>{{ getResourceName(sessionData.Resources[0]) }}</span>
          </v-tooltip>
        </v-row>
        <v-row class="mt-2 pt-3" justify="center"> Add To Calendar </v-row>
        <v-row>
          <v-col>
            <v-btn
              style="font-weight: 600"
              depressed
              block
              @click="addToCalendar('outlook')"
            >
              <v-img
                max-width="20"
                max-height="20"
                src="../../assets/e2medu/icons/outlook.png"
              /><span class="pl-2">Outlook</span>
            </v-btn> </v-col
          ><v-col>
            <v-btn
              style="font-weight: 600"
              depressed
              block
              @click="addToCalendar('google')"
            >
              <v-img
                max-width="20"
                max-height="20"
                src="../../assets/e2medu/icons/google-icon.svg"
              />
              <span class="pl-2" /> Google
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-dialog content-class="zoomDialogClass" width="600" v-model="zoomDialog">
      <v-card color="transparent" dark>
        <div style="position: absolute; right: 10px; top: 10px">
          <v-icon
            color="black"
            style="z-index: 2"
            size="32"
            @click="closeHandler()"
            >close</v-icon
          >
        </div>

        <div
          style="
            position: absolute;
            left: 10px;
            bottom: 10px;
            z-index: 2;
            width: 30%;
            padding-left: 20px;
          "
        >
          Redirecting you to Zoom in {{ countDownZoom }} sec
        </div>
        <v-img
          v-if="customLocation.includes('edulife')"
          src="../../assets/e2medu/classroom-guidelines_latest.png"
        ></v-img>
        <v-img v-else src="../../assets/e2medu/mastry_guidline.png"></v-img
      ></v-card>
    </v-dialog>
    <v-dialog
      width="800"
      content-class="zoomDialogClass"
      v-model="studentBasedRating"
    >
      <v-card>
        <v-card-title>
          <div class="h3">Session Report</div>
          <div style="position: absolute; right: 10px; top: 10px">
            <v-icon style="z-index: 2" size="32" @click="closeHandler()"
              >close</v-icon
            >
          </div></v-card-title
        >
        <v-card-text>
          <v-container ref="studentRatingForm">
            <v-row>
              <v-col class="h5 py-1"
                ><span style="font-weight: bolder">Student Name:</span>
                {{ currentStudent.Name }}</v-col
              >
              <v-col class="h5 py-1"
                ><span style="font-weight: bolder">Teacher Name:</span>
                {{
                  studentSessionData.MappedHosts
                    ? studentSessionData.MappedHosts[0].Name
                    : ""
                }}</v-col
              >
            </v-row>
            <v-row>
              <v-col class="h5 py-1">
                <span style="font-weight: bolder">Course Name:</span>
                {{
                  studentSessionData
                    ? studentSessionData.eventInfo
                      ? studentSessionData.eventInfo.EventFullName
                      : ""
                    : ""
                }}
              </v-col>
              <v-col class="h5 py-1">
                <span style="font-weight: bolder">Session Name:</span>
                {{ studentSessionData.Name }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="h5 py-1"
                ><span style="font-weight: bolder">Session Date:</span>
                {{
                  getStudentRatingSessionDate(
                    studentSessionData.StartDate
                      ? studentSessionData.StartDate._seconds * 1000
                      : ""
                  )
                }}</v-col
              >
              <v-col class="h5 py-1"
                ><span style="font-weight: bolder">Session time:</span>
                {{
                  getStudentRatingSessionTime(
                    studentSessionData.StartDate
                      ? studentSessionData.StartDate._seconds * 1000
                      : ""
                  )
                }}</v-col
              >
            </v-row>
            <v-divider style="border-bottom-width: thin"></v-divider>
            <v-row>
              <v-col cols="4">
                <span
                  style="align-self: center; font-weight: bolder"
                  class="h5"
                >
                  Understanding:</span
                >
              </v-col>
              <v-col class="pt-0"
                ><v-rating
                  length="10"
                  v-model="studentUnderstandingRating"
                  background-color="green lighten-3"
                  color="green"
                  large
                ></v-rating
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <span style="align-self: center; font-weight: bolder" class="h5"
                  >Oral/Written Performance:</span
                ></v-col
              >
              <v-col class="pt-0"
                ><v-rating
                  length="10"
                  v-model="studentOralWritingRating"
                  background-color="green lighten-3"
                  color="green"
                  large
                ></v-rating
              ></v-col>
            </v-row>
            <v-row>
              <v-col
                style="justify-content: flex-start; display: flex"
                cols="4"
              >
                <span
                  style="align-self: center; font-weight: bolder"
                  class="h5"
                >
                  Previous Assignment Feedback:</span
                ></v-col
              >
              <v-col
                ><v-text-field
                  v-model="studentPreviousHomework"
                  hint="Previous Assignment Feedback"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col
                style="justify-content: flex-start; display: flex"
                cols="4"
              >
                <span style="align-self: center; font-weight: bolder" class="h5"
                  >Assignment:</span
                ></v-col
              >
              <v-col>
                <v-text-field
                  v-model="studentHomework"
                  hint="Assignment"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col style="justify-content: flex-start; display: flex" cols="4"
                ><span
                  style="align-self: center; font-weight: bolder"
                  class="h5"
                  >Additional Remark:</span
                ></v-col
              >

              <v-col
                ><v-text-field
                  v-model="studentRemarks"
                  hint="Additional Remarks"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row justify="end">
              <v-btn
                @click="
                  reviewStudent(
                    currentStudent.Name,
                    studentSessionData.MappedHosts[0].Name,
                    studentSessionData.eventInfo.EventFullName,
                    studentSessionData.StartDate._seconds * 1000,
                    studentSessionData.Name
                  )
                "
                :disabled="studentSubmitDisabled"
                color="primary"
                >Submit</v-btn
              >
            </v-row>
          </v-container>
        </v-card-text>
      </v-card></v-dialog
    >




    <v-dialog width="1200" height="900" content-class="zoomDialogClass client-dialog" v-model="agoraDialog">
      <v-card>
        <div style="height:fit-content; !important">
          <v-row align="centre" justify="centre">
            <v-icon
              style="display: absolute"
              class="pt-3 pl-2 ml-8"
              @click="agoraDialog = false"
              size="36"
            >
              mdi-arrow-left
            </v-icon>
            <v-spacer></v-spacer>
            <div class="pt-4" v-if="agoraSessionData">
               <h3>Client Id:{{ agoraSessionData.eventInfo.ClientId }}</h3>
              <h3>Event Id:{{ agoraSessionData.eventId }}</h3>
              <h3>Session Id:{{ agoraSessionData.SessionId }}</h3>
              <h3>EventCollectionName:{{ agoraSessionData.eventInfo.EventCollectionName}}</h3>
              


            </div>
            <v-spacer></v-spacer>
          </v-row>
          <v-row justify="center" class="position-relative">
            <h3>Livepanel will show here</h3>
          </v-row>
        </div>
      </v-card></v-dialog
    >
  </div>
</template>
<script src="video.js"></script>
<script src="videojs.hls.min.js"></script>
<script>
var player = videojs("example-video");
player.play();
</script>
<script>
import store from "../../store/index";
import { VueFeedbackReaction } from "vue-feedback-reaction";
import apiHandler from "../../handler/edu_handler";
import db from "../../components/firebaseInit";
import jQuery from "jquery";
const axios = require("axios");
import VideoPlayer from "@/components/VideoPlayer.vue";
let $ = jQuery;
import SessionComponent from "../../components/edu/SessionComponent";
import helper from "../../helper/_helper";
import scroller from "../../mixins/scroller";
import APIs from "@/components/APIInit";
var CLIENT_ID = store.state.client[0].id;
const INSTANCE_ID = process.env.VUE_APP_INSTANCE_ID;
import { bus } from "@/main";
const moment = require("moment");
var self;
import { createWriteStream } from "streamsaver";
//var feedBackListener;

export const downloadFile = (url, fileName) => {
  return fetch(url).then((res) => {
    const fileStream = createWriteStream(fileName);
    const writer = fileStream.getWriter();
    if (res.body.pipeTo) {
      writer.releaseLock();
      return res.body.pipeTo(fileStream);
    }

    const reader = res.body.getReader();
    const pump = () =>
      reader
        .read()
        .then(({ value, done }) =>
          done ? writer.close() : writer.write(value).then(pump)
        );

    return pump();
  });
};
export default {
  components: {
    SessionComponent,
    VideoPlayer,
    VueFeedbackReaction,
  },
  mixins: [scroller],
  props: {},
  data() {
    return {
      agoraDialog: false,
      APIs: APIs,
      allUsersListOfClient: [],
      selectedUser: null,
      loadUser: false,
      allCourseList: [],
      selectedCourse: null,
      loadCourse: false,

      
      certificateData: [{
        course_id:"E1622478170218",
        course_name:"Grade 8 Mathematics",
        completionPercentage:42,
        attended_sessions:5,
        purchased_sessions:16
      },
      {
        course_id:"E1622478170219",
        course_name:"Chess Champion Beginners",
        completionPercentage:55,
        attended_sessions:7,
        purchased_sessions:16
      }],
      downloadVideoPath: "",
      customLocation: location.host,
      selectedSession: {},
      contentLoadedAuto: false,
      allSessionDetails: [],
      feedBackHeaderText: "",
      showFeedbackDropDown: false,
      studentUnderstandingRating: "",
      studentOralWritingRating: "",
      studentPreviousHomework: "",
      studentHomework: "",
      studentRemarks: "",
      studentSessionData: {},
      currentStudent: {},
      studentBasedRating: false,
      countDownZoomInterval: null,
      countDownZoom: 5,
      zoomDialog: false,
      submitFeedbackLoader: false,
      ratedDate: "",
      ratedSession: "",
      ratingText: "",
      feedbackComponent: false,
      notesBeforeFeedBack: "",
      feedback: 0,
      feedback1: "0",
      disableFeedbackSubmit: true,
      playListController: [],
      currentRef: "",
      videoPlayerOptions: {
        autoplay: true,
        controls: true,
      },
      dialog: false,
      playbackUrls: [],
      tabClick: { tab1: false, tab2: true },
      timelinePosition: null,
      leftPadding: "",
      selectedEvent: "",
      sessionsCount: 0,
      clientSettings: {},
      showDatePicker: false,
      showDatePickerDialog: false,
      isSessionsOnDate: false,
      lineCount: 0,
      drawer: false,
      picker: "",
      sessions: [],
      contentLoaded: false,
      sessionData: null,
      zoomDetails: {},
      currentTime: {},
      navbarHeight: 0,
      submitNavLoader: false,
      mainSessions: [],
      agoraSessionData: null
    };
  },
  computed: {
    studentSubmitDisabled() {
      return (
        !this.studentUnderstandingRating ||
        !this.studentOralWritingRating ||
        !this.studentPreviousHomework ||
        !this.studentHomework ||
        !this.studentRemarks
      );
    },
    // videoPlayer() {
    //   return this.$refs.videoPlayer.player;
    // },
    getCalendarEnable: function () {
      if (this.sessionData) {
        return (
          (this.sessionData.StartDate._seconds * 1000 <= this.currentTime &&
            this.currentTime <= this.sessionData.EndDate._seconds * 1000) ||
          this.currentTime >= this.sessionData.EndDate._seconds * 1000
        );
      } else return true;
    },
    getStatus: function () {
      if (this.sessionData) {
        if (
          (this.sessionData.StartDate._seconds - 10 * 60) * 1000 <=
            this.currentTime &&
          this.currentTime <= this.sessionData.EndDate._seconds * 1000
        ) {
          return "Live";
        } else if (
          this.currentTime >=
          this.sessionData.EndDate._seconds * 1000
        ) {
          return "Ended";
        } else {
          return "Upcoming";
        }
      }
      return "Unknown";
    },
  },
  watch: {
    countDownZoom(val) {
      if (val == 0) {
        clearInterval(this.countDownZoomInterval);
      }
    },
    zoomDialog(val) {
      if (val) {
        this.countDownZoom = 10;
        this.countDownZoomInterval = setInterval(() => {
          this.countDownZoom = this.countDownZoom - 1;
        }, 1000);
      } else {
        clearInterval(this.countDownZoomInterval);
        this.countDownZoom = 0;
      }
    },
    "$route.query.feedback": {
      handler: function (val) {
        if (val) {
          if (this.$store.state.user[0].userType == "Attendee") {
            this.notesBeforeFeedBack = "";
            this.ratedSession = this.$store.state.feedbackLastSession;
            this.ratingText = "";
            this.$store.commit("setFeedbackLastSession", {});
            this.disableFeedbackSubmit = false;
            this.feedbackComponent = true;
            this.$router.replace({ query: {} });
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.query.menufeedback": {
      handler: function (val) {
        if (val) {
          if (this.$store.state.user[0].userType == "Attendee") {
            this.getAllSessionNames();
            this.notesBeforeFeedBack = "";
            this.ratedSession = this.$store.state.feedbackLastSession;
            this.ratingText = "";
            this.$store.commit("setFeedbackLastSession", {});
            this.feedBackHeaderText =
              "Select a past session below to share class feedback";
            this.showFeedbackDropDown = true;
            this.disableFeedbackSubmit = false;
            this.feedbackComponent = true;
            this.$router.replace({ query: {} });
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.query.feedbackBeforeExpire": {
      handler: function (val) {
        if (val) {
          if (this.$store.state.user[0].userType == "Attendee") {
            this.notesBeforeFeedBack =
              "Don't forget to leave your Feedback after the class";
            this.ratedSession = this.$store.state.feedbackLastSession;
            this.ratingText = "";
            // this.$store.commit("setFeedbackLastSession", {});
            this.feedbackComponent = true;
            //this.zoomMeetingEndHook(this.$store.state.feedbackLastSession);
            this.$router.replace({ query: {} });
          }
        }
      },
      deep: true,
      immediate: true,
    },
    feedback(val) {
      if (val) {
        this.ratingText = ["Very Poor", "Poor", "Average", "Good", "Excellent"][
          val - 1
        ];
        // var reqBody = {
        //   key: {
        //     eventId: this.ratedSession.eventId,
        //     sessionId: this.ratedSession.SessionId,
        //     clientId: this.$store.state.client[0].id
        //   },
        //   data: {
        //     userId: this.$store.state.user[0].id,
        //     userName: this.$store.state.user[0].name,
        //     stars: val,
        //     ratingText: "",
        //     userAgent: navigator.userAgent
        //   }
        // };
        // this.sendRatingMail(this.ratedSession, val, "");
        // apiHandler.addReview(reqBody);
      }
    },
    dialog(val) {
      if (!val) {
        this.$refs.videoPlayer.player.reset();
        this.$refs.videoPlayer.player.close();
      }
    },
    picker(date) {
      this.timelinePosition = null;
      console.log(date);
      let time = new Date(date).getTime();
      if (time < new Date().getTime()) {
        this.tabClick.tab1 = true;
        this.tabClick.tab2 = false;
        this.getSessions(time, false, "tab1");
      } else {
        this.tabClick.tab2 = true;
        this.tabClick.tab1 = false;
        this.getSessions(time, false, "tab2");
      }

      // this.getSessions(time, false, "tab2");
    },
    selectedCourse(val) {
      if (val != null) {
        self.allUsersListOfClient = self.allUsersListOfClient.filter((user) => {
          if (user.course_id == val.EventId) {
            return user;
          }
        });
      } else {
        this.getAllUsersByClientId();
      }
    },
  },
  created() {
    self = this;
    setInterval(function () {
      self.currentTime = Date.now();
    }, 1000);

    bus.$on("openRateMeDialog", () => {
      if (this.$store.state.user[0].userType == "Attendee") {
        this.disableFeedbackSubmit = false;
        this.feedbackComponent = true;
      }
    });
    bus.$on("toggleAgora", (val) => {
      console.log("val==received=", val);
      self.agoraSessionData = val;
      self.dialog = false;
      self.agoraDialog = true;
    });
  },
  mounted() {
    CLIENT_ID = store.state.client[0].id;
    //$("#topmenu").show();
    $("#leftmenu").show();
    window.addEventListener("keydown", this.keyDownHandler);
    this.getClientConfig();
    this.selectedEvent = this.$store.state.eventid;
    this.getLeftPadding();
    let tabId = self.$route.params.tabid;

    if (tabId == null) {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      this.getSessions(firstDay.getTime(), false, "tab2");
    } else {
      self.setState(tabId);
    }
    this.getCertificateDetails();
    this.fetchCourseList();
    this.getAllUsersByClientId();
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyDownHandler);
  },
  beforeUpdate() {
    this.getLeftPadding();
  },

  methods: {
    openAgoraPlayer() {
      this.agoraDialog = true;
    },
    filterSessionList() {
      if (self.selectedCourse == null && self.selectedUser == null) {
        console.log("1=======");
        self.sessions = self.mainSessions;
      } else if (self.selectedCourse != null && self.selectedUser == null) {
        console.log("2=======");
        self.sessions = self.mainSessions;

        self.sessions = self.sessions.filter((sessions) => {
          console.log("sessions======", sessions);
          if (self.selectedCourse != null && self.selectedUser != null) {
            console.log("3=======");
            if (self.selectedCourse.EventId == sessions.eventId) {
              console.log("4=======");
              if (
                sessions.MappedHosts[0].Email.trim() == self.selectedUser.trim()
              ) {
                console.log("5=======");
                return true;
              } else {
                console.log("6=======");
                var attendeeIncluded = false;
                sessions.IncludedAttendees.map((user) => {
                  if (user.Email.trim() == self.selectedUser.trim()) {
                    attendeeIncluded = true;
                  }
                });
                return attendeeIncluded;
              }
            }
          } else if (self.selectedCourse != null && self.selectedUser == null) {
            console.log("7=======");
            if (self.selectedCourse.EventId == sessions.eventId) {
              console.log("8=======");
              return true;
            }
          } else if (self.selectedUser != null && self.selectedCourse == null) {
            console.log("9=======");
            if (
              sessions.MappedHosts[0].Email.trim() == self.selectedUser.trim()
            ) {
              console.log("10=======");
              return true;
            } else {
              console.log("11=======");
              var attendeeIncluded1 = false;
              sessions.IncludedAttendees.map((user) => {
                if (user.Email.trim() == self.selectedUser.trim()) {
                  attendeeIncluded1 = true;
                }
              });
              return attendeeIncluded1;
            }
          } else {
            return true;
          }
        });
      } else {
        console.log("12=======");
        self.sessions = self.sessions.filter((sessions) => {
          console.log("sessions======", sessions);
          if (self.selectedCourse != null && self.selectedUser != null) {
            console.log("13=======");
            if (self.selectedCourse.EventId == sessions.eventId) {
              console.log("14=======");
              if (
                sessions.MappedHosts[0].Email.trim() == self.selectedUser.trim()
              ) {
                console.log("15=======");
                return true;
              } else {
                console.log("16=======");
                var attendeeIncluded = false;
                sessions.IncludedAttendees.map((user) => {
                  if (user.Email.trim() == self.selectedUser.trim()) {
                    attendeeIncluded = true;
                  }
                });
                return attendeeIncluded;
              }
            }
          } else if (self.selectedCourse != null && self.selectedUser == null) {
            console.log("17=======");
            if (self.selectedCourse.EventId == sessions.eventId) {
              console.log("18=======");
              return true;
            }
          } else if (self.selectedUser != null && self.selectedCourse == null) {
            console.log("19=======");
            if (
              sessions.MappedHosts[0].Email.trim() == self.selectedUser.trim()
            ) {
              console.log("20=======");
              return true;
            } else {
              console.log("21=======");
              var attendeeIncluded1 = false;
              sessions.IncludedAttendees.map((user) => {
                if (user.Email.trim() == self.selectedUser.trim()) {
                  attendeeIncluded1 = true;
                }
              });
              return attendeeIncluded1;
            }
          } else {
            return true;
          }
        });
      }
    },
    fetchCourseList() {
      this.loadCourse = true;
      let headers = {
        Authorization: "Bearer " + this.getSessionToken(),
        "content-type": "application/json",
      };

      axios
        .get(this.APIs.UserEvent, {
          headers: headers,
        })
        .then((response) => {
          this.loadCourse = false;
          var result = response.data.result;
          var i;
          var j;
          for (i = 0; i < result.length; ++i) {
            for (j = 0; j < result[i].events.length; j++) {
              if (result[i].client.ClientId == "C1591205467009") {
                if (result[i].events[j].IsPublished == true) {
                  this.allCourseList.push({
                    EventId: result[i].events[j].EventId,
                    EventFullName: result[i].events[j].EventFullName,
                  });
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllUsersByClientId() {
      let headers = {
        "Content-Type": "application/json",
      };
      let rqstData = {};

      rqstData = {
        key: {
          clientId: this.$store.state.client[0].id,
        },
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-get-users",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          responseData.data.data.map((user) => {
            if (!user.user_email.includes("webspiders")) {
              const checkUsername = (obj) => obj.user_email === user.user_email;
              if (self.allUsersListOfClient.some(checkUsername)) {
                var index = self.allUsersListOfClient.findIndex(
                  (_item) => _item.user_email === user.user_email
                );

                //console.log("index=>>>>>>>>>>>>>>===", index);
                user.user_name =
                  user.user_reg_type == "Attendee"
                    ? user.user_name + " (Student)"
                    : user.user_name + " (Teacher)";
                self.allUsersListOfClient.push(user);
              } else {
                user.user_name =
                  user.user_reg_type == "Attendee"
                    ? user.user_name + " (Student)"
                    : user.user_name + " (Teacher)";
                self.allUsersListOfClient.push(user);
              }
            }
          });
          self.allUsersListOfClient.sort((a, b) =>
            b.user_name > a.user_name ? -1 : b.user_name > a.user_name ? 1 : 0
          );
          console.log(
            "allUsersListOfClient========",
            self.allUsersListOfClient
          );
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    getCertificateDetails() {
      if (this.isClientAdmin() != true) {
        let headers = {
          "content-type": "application/json",
        };

        let rqstData = {};

        rqstData = {
          key: {
            clientId: this.$store.state.client[0].id,
          },

          data: {
            attendeeId: this.$store.state.user[0].id,
          },
        };
        axios
          .post(
            "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-attendee-stat",
            rqstData,
            {
              headers: headers,
            }
          )
          .then((responseData) => {
            console.log(responseData);

            // this.certificateData = [];
            // responseData.data.data.map((course) => {
            //   course.last_session_end_date = this.SetTimeByZone(
            //     new Date(course.last_session_end_date * 1000).toUTCString(),
            //     moment.tz.guess()
            //   );
            //   course.completionPercentage = Math.round(
            //     (parseInt(course.attended_sessions) /
            //       parseInt(course.purchased_sessions)) *
            //       100
            //   );

            //   this.certificateData.push(responseData.data.data);
            // });
          })
          .catch((error) => {
            console.log("Error:" + error);
          });
      }
    },
    downloadVideo(url) {
      var startDate = this.SetTimeByZone(
        new Date(this.sessionData.StartDate._seconds * 1000).toUTCString(),
        moment.tz.guess()
      );
      var fileName =
        this.sessionData.Name +
        "_" +
        startDate +
        "_" +
        this.sessionData.MappedHosts[0].Name +
        ".mp4";
      downloadFile(url ? url : this.downloadVideoPath, fileName).then(() => {
        console.log("file downloaded");
      });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    // zoomMeetingEndHook(sessionDetails) {
    //   self = this;
    //   console.log("sessionDetails===", sessionDetails);
    //   var eventCollection =
    //     "OA_UAT_" + this.$store.state.client[0].id + sessionDetails.eventId;
    //   console.log("eventCollection===", eventCollection);

    //   feedBackListener = db
    //     .collection(eventCollection)
    //     .doc("SessionList")
    //     .collection("Sessions")
    //     .doc(sessionDetails.SessionId)
    //     .onSnapshot(
    //       (doc) => {
    //         var data = doc.data();
    //         console.log("data>>>>>>", data);
    //         self.disableFeedbackSubmit =
    //           data.MeetingStarted == undefined ? true : data.MeetingStarted;
    //       },
    //       (error) => {
    //         //alert(error);
    //         console.log(error);
    //       }
    //     );
    // },
    getReviewDetails(sessionData) {
      var self = this;
      if (sessionData != null) {
        let reqBody = {};
        var isTeacherUser =
          sessionData.MappedHosts[0].Email == this.$store.state.user[0].Email
            ? true
            : false;
        reqBody = {
          key: {
            sessionId: sessionData.SessionId,
            clientId: CLIENT_ID,
            eventId: sessionData.eventId,
            isTeacher: isTeacherUser,
          },
          data: {
            userId: this.$store.state.user[0].id,
          },
        };

        apiHandler
          .getReviews(reqBody)
          .then((res) => {
            var data = res.data;
            if (data.length > 0) {
              data.map((review) => {
                if (self.$store.state.user[0].id == review.userId) {
                  self.ratingText = review.ratingText;
                  self.ratedDate = review.date;
                  self.feedback = parseFloat(review.stars);
                  self.feedback1 = "3";
                }
              });
            } else {
              self.ratingText = "";
              self.ratedDate = "";
              self.feedback = 0;
            }
          })
          .catch(() => {});
      } else {
        self.ratingText = "";
        self.ratedDate = "";
        self.feedback = 0;
      }
    },
    getAllSessionNames() {
      this.contentLoadedAuto = true;
      this.allSessionDetails = [];
      var currentTime = new Date().getTime();
      let body = {
        instanceId: INSTANCE_ID,
        clientId: CLIENT_ID,
        attendeeId: this.$store.state.user[0].id,
        data: {},
      };
      apiHandler
        .getAllSessionsByEvents(body)
        .then((result) => {
          result.data.data.forEach((sessionSnap) => {
            if (
              sessionSnap.IncludedAttendees &&
              sessionSnap.IncludedAttendees.length > 0
            ) {
              sessionSnap.AttendeeNames =
                this.getStudentNames(sessionSnap.IncludedAttendees) != undefined
                  ? this.getStudentNames(sessionSnap.IncludedAttendees)
                  : "No Student";
            } else {
              sessionSnap.AttendeeNames = "No Student";
            }
            if (currentTime >= sessionSnap.EndDate._seconds * 1000) {
              this.allSessionDetails.push(sessionSnap);
            }

            this.allSessionDetails.sort((a, b) =>
              a.StartDate._seconds > b.StartDate._seconds
                ? -1
                : b.StartDate._seconds > a.StartDate._seconds
                ? 1
                : 0
            );
            this.contentLoadedAuto = false;
          });
        })
        .catch((err) => {
          console.log(err);
          this.contentLoadedAuto = false;
        });
    },
    getStudentNames(attendeeList) {
      var names = [];
      attendeeList.map((attendee) => {
        names.push(attendee.FirstName);
      });
      return names.join(",");
    },
    createdSessionName: (item) =>
      item.Name +
      "  (" +
      item.eventInfo.EventFullName +
      ")" +
      " (" +
      item.AttendeeNames +
      ")",
    goToPreviousDate() {
      let yourDate = new Date();
      if (this.picker) {
        yourDate = new Date(this.picker);
      }
      let prevDate = new Date(
        yourDate.getFullYear(),
        yourDate.getMonth() - 1,
        1
      );
      let prevDateString = moment(prevDate).format("YYYY-MM-DD").toString();
      this.picker = prevDateString;
      //this.filterSessionList();
    },
    sendStudentRatingMail(htmlParam) {
      let to = [this.currentStudent.Email, "support@edulife.sg"];
      var from;
      var cc;
      var bcc;
      if (location.host.includes("edulife"))
        from = { email: "feedback@edulife.sg", name: "EduLife Feedback" };
      else from = { email: "support@mastry.io", name: "Team Mastry" };
      bcc = this.studentSessionData.MappedHosts[0].Email;
      //bcc = [this.studentSessionData.MappedHosts[0].Email , 'support@edulife.sg'];
      if (location.host.includes("edulife")) {
        cc = "feedback@edulife.sg";
        //bcc = bcc;
      } else {
        cc = "debottam.bhatt@webspiders.com,debashis.giri@webspiders.com";
        bcc = bcc + ",feedback@mastry.io";
      }

      let html = htmlParam;
      let subject = `Session Report: ${this.studentSessionData.Name} - ${this.studentSessionData.eventInfo.EventFullName}`;
      let mailObject = {
        to,
        from,
        html,
        subject,
        cc,
        bcc,
      };
      console.log("mailObject====", mailObject);
      apiHandler.sendMail(mailObject);
    },
    reviewStudent(student, teacher, eventName, date, sessionName) {
      let studentDate = this.getStudentRatingSessionDate(date);
      let studentTime = this.getStudentRatingSessionTime(date);
      var html;
      if (location.host.includes("edulife")) {
        html = `<html lang="en-US"> <head> <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,600;1,400;1,500&display=swap" rel="stylesheet"> <style>td {font-size:16px;font-weight:600;font-family: 'Poppins', sans-serif !important;} img{max-width:100%} </style> </head> <div class="" style="width:90%;margin:0 auto;background-color:#f2f2f2;padding:40px" > <div class="" style="width:600px;margin:0 auto;background-color:#ffffff;padding:40px" > <table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" > <tbody> <tr> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding-bottom:20px"> <a href="https://edulife.sg/home" target="_blank"> <img src="https://s3.amazonaws.com/unroll-images-production/projects%2F0%2F1623830177018-email-banner.jpg" width="600px"> </a> </td> </tr> </table> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:30px 10px 10px;font-family:'Lato',sans-serif;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;padding-bottom:15px" align="center"> <span style="font-size:18px;font-weight:600;border-bottom: 1px solid #000000;">SESSION REPORT</span> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding-top:40px;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0" style="font-size:16px;font-weight:600"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Date: ${studentDate} </p> </td> <td> <p style=""></p> </td> </tr> <tr> <td> <p style="">Student Name: ${student}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Course Name: ${eventName}</p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> <td style="padding-right: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Time: ${studentTime}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Teacher Name: ${teacher}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Session Name: ${sessionName}</p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="padding-top:40px;"> <p>Understanding: ${this.studentUnderstandingRating}/10</p> <p>Oral/Written Class Performance: ${this.studentOralWritingRating}/10 </p> <p>Previous Assignment: ${this.studentPreviousHomework} </p> <p>Assignment : ${this.studentHomework} </p> <p>Additional Remark: ${this.studentRemarks} </p> </td> </tr> </tbody> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding:20px "> <img src="https://s3.amazonaws.com/unroll-images-production/projects%2F0%2F1623077639730-unnamed+%282%29.png"  width="600px"> </td> </tr> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"> <tr> <td colspan="3" style="padding:0cm 0cm 0cm 0cm"> <p class="MsoNormal" align="center" style="text-align:center"> <span style="color:black"><a href="https://www.facebook.com/edulifesingapore" target="_blank"><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Ffacebook.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222">  </span><span style="color:black;padding:0 8px;"> <a href="https://www.instagram.com/edulifesg/" target="_blank" ><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" id="m_3276429931951355163m_4809426333270075598m_-7723710672828629258_x0000_i1027" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Finsta.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222">  </span><span style="color:black"> <a href="https://www.linkedin.com/in/edulife-singapore-b605a91b2/ " target="_blank"><span style="font-size:12.0pt;text-decoration:none"><img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Flinkdin.png?alt=media" class="CToWUd"></span></a></span> </p> <p align="center" style="margin-bottom:22.5pt;text-align:center"><span style="font-size:9.0pt;font-family:Times New Roman,serif;color:#222222">© Copyright EduLife 2021. All Rights Reserved<u></u><u></u></span></p> </td> </tr> </table> </td> </tr> </tbody> </table> </div> </div> </body> </html>`;
      } else {
        html = `<html lang="en-US"> <head> <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,600;1,400;1,500&display=swap" rel="stylesheet"> <style>td {font-size:16px;font-weight:600;font-family: 'Poppins', sans-serif !important;} img{max-width:100%} </style> </head> <div class="" style="width:90%;margin:0 auto;background-color:#f2f2f2;padding:40px" > <div class="" style="width:600px;margin:0 auto;background-color:#ffffff;padding:40px" > <table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" > <tbody> <tr> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding-bottom:20px"> <a href="https://www.mastry.io/" target="_blank"> <img src="https://mars.webspiders.com/Prototype/Mastry/mastry.png" alt="Mastry" width="600px"> </a> </td> </tr> </table> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:30px 10px 10px;font-family:'Lato',sans-serif;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;padding-bottom:15px" align="center"> <span style="font-size:18px;font-weight:600;border-bottom: 1px solid #000000;">SESSION REPORT</span> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding-top:40px;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0" style="font-size:16px;font-weight:600"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Date: ${studentDate} </p> </td> <td> <p style=""></p> </td> </tr> <tr> <td> <p style="">Student Name: ${student}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Course Name: ${eventName}</p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> <td style="padding-right: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Time: ${studentTime}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Teacher Name: ${teacher}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Session Name: ${sessionName}</p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="padding-top:40px;"> <p>Understanding: ${this.studentUnderstandingRating}/10</p> <p>Oral/Written Class Performance: ${this.studentOralWritingRating}/10 </p> <p>Previous Assignment: ${this.studentPreviousHomework} </p> <p>Assignment : ${this.studentHomework} </p> <p>Additional Remark: ${this.studentRemarks} </p> </td> </tr> </tbody> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"> <tr> <td colspan="3" style="padding:0cm 0cm 0cm 0cm"> <p class="MsoNormal" align="center" style="text-align:center"> <span style="color:black"><a href="https://www.facebook.com/Mastry-118511360415858" target="_blank"><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Ffacebook.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222"> </span><span style="color:black;padding:0 8px;"> <a href="https://www.instagram.com/mastry.io/" target="_blank" ><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" id="m_3276429931951355163m_4809426333270075598m_-7723710672828629258_x0000_i1027" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Finsta.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222"> </span><span style="color:black"> <a href="https://www.linkedin.com/company/mastry-io" target="_blank"><span style="font-size:12.0pt;text-decoration:none"><img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Flinkdin.png?alt=media" class="CToWUd"></span></a></span> </p> <p align="center" style="margin-bottom:22.5pt;text-align:center"><span style="font-size:9.0pt;font-family:Times New Roman,serif;color:#222222">© Copyright Mastry 2021. All Rights Reserved<u></u><u></u></span></p> </td> </tr> </table> </td> </tr> </tbody> </table> </div> </div> </body> </html>`;
      }
      let key = {
        sessionId: this.studentSessionData.SessionId,
        clientId: this.$store.state.client[0].id,
        eventId: this.studentSessionData.eventId,
        userId: this.$store.state.user[0].id,
      };
      let studentRatingObject = {
        student,
        teacher,
        eventName,
        date: new Date(date).getTime(),
        sessionName,
        studentUnderstandingRating: this.studentUnderstandingRating,
        studentOralWritingRating: this.studentOralWritingRating,
        studentPreviousHomework: this.studentPreviousHomework,
        studentHomework: this.studentHomework,
        studentRemarks: this.studentRemarks,
      };
      apiHandler.setSessionParticipantsReviews({
        key,
        data: studentRatingObject,
      });
      this.sendStudentRatingMail(html);
      this.showSnackbar("Successfully Rated Student");
      this.closeHandler();
    },
    getStudentRatingSessionDate(date) {
      if (date) {
        return moment(new Date(date)).format("MMM Do, YYYY");
      } else return "";
    },
    getStudentRatingSessionTime(date) {
      if (date) {
        return moment(new Date(date)).tz("Asia/Singapore").format("hh:mm A");
      } else return "";
    },
    setStudentBasedRating(item) {
      this.studentSessionData = this.sessionData;
      this.currentStudent = item;
      this.studentBasedRating = true;
    },
    closeHandler() {
      this.studentSessionData = {};
      this.zoomDialog = false;
      1;
      this.ratingText = "";
      this.studentBasedRating = false;
      this.currentStudent = {};
      this.studentUnderstandingRating;
      this.studentOralWritingRating = "";
      this.studentPreviousHomework = "";
      this.studentHomework = "";
      this.studentRemarks = "";
    },
    cancelFeedback() {
      this.ratingText = "";
      this.$router.replace({ query: {} });
      this.feedbackComponent = false;
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      this.getSessions(firstDay.getTime(), false, "tab1");
      this.ratingText = "";
      this.feedback = 0;
      this.$nextTick(() => {
        this.$store.commit("setFeedbackLastSession", {});
      });
    },
    getFeedbackCreationDate() {
      return moment(new Date(this.ratedDate)).format("MMM Do, hh:mm A");
    },
    getFeedbackSessionDate() {
      if (this.ratedSession.StartDate._seconds) {
        return moment(
          new Date(this.ratedSession.StartDate._seconds * 1000)
        ).format("MMM Do, hh:mm A");
      } else {
        return null;
      }
    },
    async submitFeedback() {
      let feedbackValue = this.feedback;
      this.submitFeedbackLoader = true;
      var reqBody = {};
      if (this.allSessionDetails.length == 0) {
        reqBody = {
          key: {
            eventId: this.ratedSession.eventId,
            sessionId: this.ratedSession.SessionId,
            clientId: this.$store.state.client[0].id,
          },
          data: {
            userId: this.$store.state.user[0].id,
            userName: this.$store.state.user[0].name,
            stars: feedbackValue,
            ratingText: this.ratingText,
            userAgent: navigator.userAgent,
          },
        };
      } else {
        reqBody = {
          key: {
            eventId: this.selectedSession.eventId,
            sessionId: this.selectedSession.SessionId,
            clientId: this.$store.state.client[0].id,
          },
          data: {
            userId: this.$store.state.user[0].id,
            userName: this.$store.state.user[0].name,
            stars: feedbackValue,
            ratingText: this.ratingText,
            userAgent: navigator.userAgent,
          },
        };
      }

      await apiHandler.addReview(reqBody);
      this.sendRatingMail(this.ratedSession, feedbackValue, this.ratingText);
      this.ratingText = "";
      this.feedback = 0;
      this.feedbackComponent = false;
      this.$store.commit("setFeedbackLastSession", {});
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      this.submitFeedbackLoader = false;
      this.getSessions(firstDay.getTime(), false, "tab1");
    },
    resetVideo(video, pos) {
      this.playListController.forEach((element) => {
        element.clicked = false;
      });
      this.playListController[pos].clicked = true;
      let playList = [video];
      let timeElapsed = 0;
      this.$nextTick(() => {
        this.$refs.videoPlayer.player.playlist(playList);
        this.$refs.videoPlayer.player.playlist.autoadvance(0);
        this.$refs.videoPlayer.player.currentTime(timeElapsed);
        this.$refs.videoPlayer.player.play();
        this.$refs.videoPlayer.player.playlist(playList);
      });
    },
    zoomDialogEmit(val) {
      this.zoomDialog = val;
    },
    rateMe(sessionData) {
      this.ratedSession = sessionData;
      this.ratingText = sessionData.ratingText;
      this.ratedDate = sessionData.ratedDate;
      this.ratingText = "";
      this.disableFeedbackSubmit = false;
      this.feedbackComponent = true;
    },
    getVideoOnDemand(sessionData) {
      this.sessionData = sessionData;
      let url = sessionData.Zoom_Detail.start_url;
      this.getOnDemand(url);
    },
    playVideo: function (source, timeElapsed) {
      let playList = [];
      source.forEach(function (item) {
        var type = "application/x-mpegurl";
        if (item.toLowerCase().endsWith(".mp4")) {
          //alert("mp4 found");
          type = "video/mp4";
        } else {
          //alert(item);
        }
        playList.push({
          sources: [
            {
              src: item,
              type: type,
            },
          ],
        });
      });
      this.playListController = [];
      playList.forEach((element, i) => {
        if (i == 0) element.clicked = true;
        else element.clicked = false;
        this.playListController.push(element);
      });
      this.$refs.videoPlayer.player.reset();
      this.$refs.videoPlayer.player.playlist(playList);
      this.$refs.videoPlayer.player.playlist.autoadvance(0);
      this.$refs.videoPlayer.player.currentTime(timeElapsed);
      this.$refs.videoPlayer.player.play();
    },
    dowloadFile(url) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.getResourceName(url);
          link.click();
          URL.revokeObjectURL(link.href);
          this.showSnackbar("Download Started");
        })
        .catch(console.error);
    },
    getResourceName(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
    setState(tab) {
      console.log("tab>>>>>", tab);

      if (this.tabClick[tab]) return;
      else this.tabClick.tab1 = false;
      this.tabClick.tab2 = false;
      this.tabClick.tab1 = false;
      this.tabClick[tab] = true;
      if (this.picker)
        this.getSessions(new Date(this.picker).getTime(), false, tab);
      else {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.getSessions(firstDay.getTime(), false, tab);
      }
      // if (tab == "tab2") {
      //   var date = new Date();
      //   this.picker = moment(date).format("YYYY-MM-DD").toString()
      //   var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      //   this.getSessions(firstDay.getTime(), false, "tab2");
      // }
    },
    timelineIndex: function (a) {
      return this.timelinePosition == a;
    },
    getLeftPadding() {
      let self = this;
      this.$nextTick(() => {
        setTimeout(() => {
          let width = this.$refs.SessionCalendar
            ? this.$refs.SessionCalendar.clientWidth
            : 0;
          if (this.$vuetify.breakpoint.mobile) width = 0;
          self.leftPadding = `padding-left:${width}px;`;
        }, 0);
      });
    },
    keyDownHandler(event) {
      if (event.code === "Escape") {
        this.drawer = false;
      }
    },
    sendMessage(sessionDetails) {
      if (!sessionDetails.isHost) {
        let senderName = this.$store.state.user[0].name;
        let sessionName = sessionDetails.Name;
        let recieverName = sessionDetails.MappedHosts[0].Name;
        let recieverId = sessionDetails.MappedHosts[0].AttendeeId;
        let body = `Hi ${recieverName},${senderName}(Student) has joined your class ${sessionName} of course ${sessionDetails.eventInfo.EventFullName}`;
        const msg = {
          userId: [recieverId],
          body: body,
          messagetype: "session joined",
        };
        apiHandler.sendMessage(msg);
      }
    },
    sendRatingMail(sessionDetails, stars, comments) {
      var to;
      var from;
      var cc;
      if (location.host.includes("edulife")) {
        to = "feedback@edulife.sg";
        cc = "support@edulife.sg";
        from = { email: "booking@edulife.sg", name: "EduLife Feedback" };
      } else {
        to = "vivek.somani@webspiders.com";
        from = { email: "support@mastry.io", name: "Team Mastry" };
      }
      let recieverName = "Admin";
      let currDate = new Date();
      let type = "";
      if (sessionDetails.isHost) {
        type = "Teacher";
      } else {
        type = "Student";
      }
      var html;
      if (location.host.includes("edulife")) {
        html = `<html><body><p>Dear ${recieverName},</p><div>Below is the feedback received from ${
          this.$store.state.user[0].name
        } (${type})</div><div>${type} Name: ${
          this.$store.state.user[0].name
        }.</div><div>${type} Email: ${
          this.$store.state.user[0].Email
        }.</div><div>Session Name: ${
          sessionDetails.Name
        }.</div><div>Time of feedback: ${moment(currDate).format(
          "MMM Do, hh:mm A"
        )}</div><div>Feedback Rating: ${stars}/5</div><div>Comments: ${comments}</div></br></br><p>Thank you! </p></br> Team EduLife
          </body></ html>`;
      } else {
        html = `<html><body><p>Dear ${recieverName},</p><div>Below is the feedback received from ${
          this.$store.state.user[0].name
        } (${type})</div><div>${type} Name: ${
          this.$store.state.user[0].name
        }.</div><div>${type} Email: ${
          this.$store.state.user[0].Email
        }.</div><div>Session Name: ${
          sessionDetails.Name
        }.</div><div>Time of feedback: ${moment(currDate).format(
          "MMM Do, hh:mm A"
        )}</div><div>Feedback Rating: ${stars}/5</div><div>Comments: ${comments}</div></br></br><p>Thank you! </p></br> Team Mastry
          </body></ html>`;
      }
      let subject = `Session Feedback received from ${
        this.$store.state.user[0].name
      }: ${moment(currDate).format("Do, MMM")}`;
      let mailObject = { to, from, html, subject, cc };
      apiHandler.sendMail(mailObject);
    },

    sendMail(sessionDetails) {
      let to = "";
      var from;
      if (location.host.includes("edulife")) {
        from = { email: "sessionalerts@edulife.sg", name: "EduLife Alerts" };
      } else {
        from = { email: "support@mastry.io", name: "Team Mastry" };
      }

      let cc = "";
      let senderName = "";
      let recieverName = "";
      let sessionName = sessionDetails.Name;
      let eventName = sessionDetails.eventInfo.EventFullName;
      if (sessionDetails.isHost) {
        if (location.host.includes("edulife")) {
          to = "sessionalerts@edulife.sg";
          recieverName = "EduLife Alerts";
          senderName = this.$store.state.user[0].name + "(Teacher)";
          cc = "support@edulife.sg";
        } else {
          to = "support@mastry.io";
          recieverName = "Team Mastry";
          senderName = this.$store.state.user[0].name + "(Teacher)";
          cc = "vivek.somani@webspiders.com";
        }
      } else {
        recieverName = sessionDetails.MappedHosts[0].Name;
        senderName = this.$store.state.user[0].name + "(Student)";
        to = sessionDetails.MappedHosts[0].Email;
        if (location.host.includes("edulife")) {
          cc = "support@edulife.sg, sessionalerts@edulife.sg";
        } else {
          cc = "vivek.somani@webspiders.com,support@mastry.io";
        }
      }
      if (location.host.includes("edulife")) {
        var html = `<html><body><p>Dear ${recieverName},</p></br>${senderName} has joined the class <b>${sessionName}</b> of course <b>${eventName}</b>.</br></br><p>Thank you! </p></br>Team EduLife</body></ html>`;
      } else {
        var html = `<html><body><p>Dear ${recieverName},</p></br>${senderName} has joined the class <b>${sessionName}</b> of course <b>${eventName}</b>.</br></br><p>Thank you! </p></br>Team Mastry</body></ html>`;
      }
      let subject = `${
        sessionDetails.isHost
          ? "Teacher joined the class"
          : "Student joined your class"
      }`;
      let mailObject = { to, from, html, subject };
      if (cc) mailObject.bcc = cc;
      if (location.host.includes("edulife")) {
        mailObject.replyTo = "sessionalerts@edulife.sg";
      } else {
        mailObject.replyTo = "support@mastry.io";
      }
      apiHandler.sendMail(mailObject);
    },
    getClientConfig() {
      apiHandler.getClientConfig({ clientId: CLIENT_ID }).then((res) => {
        this.clientSettings = res;
      });
    },
    closeDrawer(sessionDetails) {
      let analyticsObject = {
        eventId: sessionDetails.eventInfo.EventId,
        action: "Close Session Drawer",
        actionLabel: "Session Click",
        actionType: "view",
        pageName: this.$route.name,
        eventName: sessionDetails.eventInfo.EventFullName,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
    },
    addToCalendar(type) {
      let analyticsObject = {
        eventId: this.sessionData.eventInfo.EventId,
        action: `Add to calendar (${type})`,
        actionLabel: type,
        actionType: "view",
        pageName: this.$route.name,
        eventName: this.sessionData.eventInfo.EventFullName,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      let title = this.sessionData.Name;
      let description = this.sessionData.Description
        ? this.sessionData.Description
        : "No description found";
      let startDate = moment(
        new Date(this.sessionData.StartDate._seconds * 1000)
      ).format("DD-MM-YYYY HH:mm");
      let endDate = moment(
        new Date(this.sessionData.EndDate._seconds * 1000)
      ).format("DD-MM-YYYY HH:mm");

      var url = `https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401&start=${startDate}&end=${endDate}&title=${title}&description=${description}&timezone=timezone&service=${type}`;
      window.open(url);
    },
    isCurrentDate(session) {
      return (
        this.getSessionDate(new Date(session.StartDate._seconds * 1000)) ==
          this.getSessionDate(new Date()) ||
        session.StartDate._seconds * 1000 >= new Date().getTime()
      );
    },

    getSessionDate(date) {
      return helper.getFormattedSessionDate(date);
    },
    checkDate(index) {
      if (index == 0) return true;
      else {
        return !(
          helper.getFormattedSessionDate(
            new Date(this.sessions[index].StartDate._seconds * 1000)
          ) ==
          helper.getFormattedSessionDate(
            new Date(this.sessions[index - 1].StartDate._seconds * 1000)
          )
        );
      }
    },
    routeToZoom(type = "") {
      let analyticsObject = {
        eventId: this.sessionData.eventInfo.EventId,
        action: "Join Session",
        actionLabel: "Join Now",
        actionType: "view",
        pageName: this.$route.name,
        eventName: this.sessionData.eventInfo.EventFullName,
      };
      apiHandler.sendEventAnalytics(analyticsObject);

      if (type == "onDemand") {
        this.submitNavLoader = true;
        let url = this.zoomDetails.Zoom_Detail.start_url;
        this.getOnDemand(url);
      } else {
        this.$store.commit("setFeedbackLastSession", this.sessionData);
        this.sendMail(this.sessionData);
        this.sendMessage(this.sessionData);
        if (this.sessionData.isHost) {
          this.zoomDialog = true;
          setTimeout(() => {
            this.zoomDialog = false;
            window.open(this.zoomDetails.Zoom_Detail.start_url);
          }, 10000);
        } else {
          window.open(this.zoomDetails.Zoom_Detail.join_url);
        }
      }
    },
    async getOnDemand(meetingUrl) {
      let meetingId = meetingUrl.substring(
        meetingUrl.lastIndexOf("/") + 1,
        meetingUrl.lastIndexOf("?")
      );
      let url = "https://videoapi.e2m.live/get-zoom-vod-urls";
      let body = { meetingIds: [meetingId] };
      let res = await axios.post(url, body);
      if (
        res.data &&
        res.data.length > 0 &&
        res.data[0].playbackUrls &&
        res.data[0].playbackUrls.length > 0
      ) {
        this.playbackUrls = res.data[0].playbackUrls;
        this.downloadVideoPath = res.data[0].playbackUrls;
        this.dialog = true;
        this.submitNavLoader = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.playVideo(this.playbackUrls, 0);
          }, 1000);
        });
      } else {
        this.submitNavLoader = false;
        this.showSnackbar("No plaback data found", "error");
      }
    },
    getFormatted(date) {
      return helper.getFormattedAssignDate(date);
    },
    getTime(date) {
      if (!date) return "";
      return helper.getTime(date);
    },
    loadDrawerComponents(sessionDetails) {
      let analyticsObject = {
        eventId: sessionDetails.eventInfo.EventId,
        action: "Open Session Drawer",
        actionLabel: "Session Click",
        actionType: "view",
        pageName: this.$route.name,
        eventName: sessionDetails.eventInfo.EventFullName,
      };
      apiHandler.sendEventAnalytics(analyticsObject);
      this.sessionData = sessionDetails;
      this.submitNavLoader = true;
      if (
        sessionDetails.SessionTypeDetails.RoundTableTopic &&
        sessionDetails.SessionTypeDetails.RoundTableTopic.TopicId
      ) {
        apiHandler
          .getZoomMeetingDetails({
            instanceId: INSTANCE_ID,
            clientId: CLIENT_ID,
            eventId: sessionDetails.eventId,
            topicId: sessionDetails.SessionTypeDetails.RoundTableTopic.TopicId,
          })
          .then((res) => {
            this.sessionData.isHost = sessionDetails.isHost;
            this.zoomDetails = res.data.data;
            this.drawer = true;
          })
          .finally(() => {
            this.submitNavLoader = false;
          });
      } else {
        this.zoomDetails.Zoom_Detail = sessionDetails.Zoom_Detail;
        this.sessionData.isHost = sessionDetails.isHost;
        this.drawer = true;
        this.submitNavLoader = false;
      }
    },
    getSessions(time = null, check = false, isMount = "") {
      this.sessionsCount = 0;
      this.showDatePickerDialog = false;
      this.contentLoaded = true;
      this.sessions = [];
      let body = {
        instanceId: INSTANCE_ID,
        clientId: CLIENT_ID,
        attendeeId: this.$store.state.user[0].id,
        eventId: this.selectedEvent,
        data: {},
      };
      if (this.$store.state.user[0].roles.includes(2)) {
        body.isClient = true;
      }
      if (time) {
        time = time / 1000;
        body.startDate = time;
      } else {
        time = 0;
      }
      apiHandler
        .getAllSessionsByEvents(body)
        .then((result) => {
          result.data.data.forEach((sessionSnap) => {
            if (!self.selectedEvent) self.sessions.push(sessionSnap);
            else {
              if (sessionSnap.eventId == self.selectedEvent) {
                self.sessions.push(sessionSnap);
              }
            }
          });

          var start = new Date();

          if (isMount == "tab1") {
            self.sessions = self.sessions.filter(
              (session) =>
                (session.EndDate._seconds - 30 * 60) * 1000 < start.getTime()
            );
          } else if (isMount == "tab2") {
            self.sessions = self.sessions.filter(
              (session) =>
                (session.EndDate._seconds + 30 * 60) * 1000 >= start.getTime()
            );
          }

          // if (isMount == "tab1") {
          //   self.sessions = self.sessions.filter(
          //     (session) => (session.EndDate._seconds + 30 * 60) * 1000 < start.getTime()
          //   );
          // }

          self.timelinePosition = -1;
          self.sessions.forEach((sessionSnap, i) => {
            if (new Date().getTime() > sessionSnap.StartDate._seconds * 1000) {
              self.timelinePosition = i;
            }
          });
          if (self.picker != "") {
            self.isSessionsOnDate =
              self.sessions.findIndex(
                (e) =>
                  self.getFormatted(new Date(e.StartDate._seconds * 1000)) ==
                  self.getFormatted(new Date(self.picker.toString()))
              ) == -1
                ? true
                : false;
          }
          self.sessionsCount = self.sessions.length;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          self.mainSessions = self.sessions;
          self.contentLoaded = false;
          self.$nextTick(() => {
            if (check) {
              self.scrollToClass("scrollPos");
              let navHeight = document.getElementById("divHeader");
              self.navbarHeight = navHeight ? navHeight.clientHeight : 0;
            } else {
              window.scrollTo(0, 0);
            }
          });
          self.filterSessionList();
        });
    },
  },
};
</script>
<style>
.fixed-top-dialog-head {
  position: sticky;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 4;
  background: #fff;
}
.progress-number-right {
  position: absolute;
  right: 0;
  margin-top: 2px;
  top: 100%;
  font-size: 8px;
  display: inline-block;
  background: #79ba7e;
  color: #fff;
  padding: 1px 5px;
  border-radius: 50px;
}
.download-watch-now {
  position: absolute !important;
  right: 6%;
  bottom: 3%;
}
.zoomDialogClass {
  border-radius: 24px !important;
}

.zoomDialogClass input[type="text"] {
  border-bottom: 1px solid #dfdfdf !important;
  padding: 15px !important;
}
</style>
<style scoped>
.zoomDialogClass {
  border-radius: 24px !important;
}

.v-picker--date .v-date-picker-table .v-btn {
  color: white;
}
.bgImage {
  position: fixed;
  background-size: cover;
}
.sessionBody {
  height: 100% !important;
  font-family: "Poppins", sans-serif !important;
}
.sessionFont {
  font-family: "Poppins", sans-serif !important;
}
.material-icons {
  font-family: "Material Icons" !important;
}
.grey-text {
  color: #7d8489;
}
.mf {
  font-weight: 500;
}
.h2 {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
}
.sm-heading {
  font-size: 18px;
  font-weight: 600;
}
.v-overlay .v-overlay__scrim {
  position: fixed;
}

.v-date-picker-table .v-btn.v-btn--active {
  color: #fff !important;
}
.right-sidebar.v-navigation-drawer {
  will-change: inherit;
}
.right-sidebar.v-navigation-drawer {
  font-size: 16px;
  color: #000000;
}
.right-sidebar.v-navigation-drawer .v-btn.v-btn--block {
  letter-spacing: inherit;
  height: 50px;
  font-weight: 600 !important;
  padding: 12px 10px;
  font-size: 16px;
}
.hrdot {
  background: #ea4335;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  content: "";
  position: static;
  height: 8px;
  margin-left: -6.5px;
  margin-top: -6px;
  width: 8px;
  z-index: 505;
}
.hr {
  margin-top: 25px;
  position: static;
  z-index: 505;
  border-top: #ea4335 solid 2px;
  left: 19%;
  right: 1.5%;
  pointer-events: none;
}
.page-wrap-inner {
  height: 100% !important;
}
</style>
<style>
.videoElement > .vjs-custom-skin.vjs-custom-skin {
  height: 70vh !important;
  width: 70% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.videoElement > .vjs-custom-skin.vjs-custom-skin .video-js {
  height: 100% !important;
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.videoElement > .vjs-control-bar .vjs-fullscreen-control {
  display: block !important;
}
.vjs-control-bar .vjs-fullscreen-control {
  display: block !important;
}
.videoElement > .vjs-icon-play,
.video-js .vjs-play-control .vjs-icon-placeholder,
.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  font-family: VideoJS !important;
}

.videoElement > .vjs-icon-volume-high,
.video-js .vjs-mute-control .vjs-icon-placeholder {
  font-family: VideoJS !important;
}

.videoElement > .vjs-icon-fullscreen-enter,
.video-js .vjs-fullscreen-control .vjs-icon-placeholder {
  font-family: VideoJS !important;
  display: block;
}
.vjs-icon-picture-in-picture-enter,
.vjs-picture-in-picture-control .vjs-icon-placeholder {
  font-family: VideoJS !important;
  display: none;
}
.video-part {
  height: 55px;
  width: 100px;
  flex: 100px 0 0;
  background: url(../../assets/Images/video-back.jpg) no-repeat center center /
    100%;
}
/* .videopart-wrap {
    height: 500px;
} */
.video-play-list-wrap {
  height: 100%;
  border: 1px solid #cbcbcb;
}
.playlist-head {
  padding: 13px 10px;
  background: #f3f3f3;
  border-bottom: 1px solid #cbcbcb;
}
.playlist-head h5 {
  font-size: 16px;
  color: #333;
  margin: 0 !important;
  font-weight: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.play-video-listing {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding: 5px !important;
}
.play-video-listing:hover,
.play-video-listing:focus {
  background: #f1f1f1;
}
.video-details-wrap p {
  margin-bottom: 0 !important;
}
.video-details-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 0 10px;
}
.videolist-wrap-hld {
  height: calc(100% - 46px);
  overflow-y: auto;
}
.no-class-session {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.no-class-session p {
  font-size: 18px;
  color: #888889;
  margin: 0;
  font-weight: 400;
}
</style>